import React from 'react';
import { ReactComponent as Notes } from '../../assets/images/icons/notes.svg';

export default function NotesIcon({ className }) {
  return (
    <Notes className={`icon ${className}`} />
  );
}
